import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const WEB_API = `${BACKEND_URL}/api/web`;

const webClient = axios.create({
  baseURL: WEB_API,
  // Send the httpOnly `web_session` cookie on every request so the user
  // stays logged-in across browser restarts and cache clears.
  withCredentials: true,
});

webClient.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("web_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

webClient.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (!path.startsWith("/admin")) {
        localStorage.removeItem("web_token");
        // Soft redirect to landing — but ONLY if we're on a protected page.
        // /, /login and /registro are anonymous-friendly and must not redirect.
        const ANON_OK = ["/", "/login", "/registro"];
        if (!ANON_OK.includes(path)) {
          window.location.href = "/";
        }
      }
    }
    return Promise.reject(err);
  }
);

export default webClient;

export const getWebToken = () => localStorage.getItem("web_token");
